module.exports = __webpack_public_path__ + "img/cheat@2x.21728ffd.png";